import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import GreenLogo from "../Innovators/GreenLogo";
import IMEAltLogo from "./IMEAltLogo";
import CommunityBanner from "./CommunityBanner";

const ProfileBackgroundPicsEdit = ({
  setFile,
  imageFile,
  user: { avatar, role, community_banner },
  setDataFile,
  imageDataFile,
}) => {
  return (
    <Fragment>
      <div
        className={`${
          imageFile.one === "" && imageFile.two === ""
            ? "edit-profile-overlay"
            : "edit-profile-overlay-alt"
        }`}
      >
        <span className="fa-stack edit-circle-plus-banner cursor">
          <label className="fa-stack icon-font cursor" htmlFor="imageone">
            <span className="fa-stack cursor">
              <i
                className={`far fa-circle fa-stack-2x  ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
              <span className={`fa fa-stack-1x`}>
                <i className="fas fa-plus fa-lg white"></i>
              </span>
            </span>
          </label>
          <input
            className="file-upload"
            type="file"
            name="file"
            id="imageone"
            multiple
            onChange={(e) => {
              setFile({
                ...imageFile,
                one: URL.createObjectURL(e.target.files[0]),
              });
              setDataFile({
                ...imageDataFile,
                one: e.target.files[0],
              });
            }}
          />
        </span>
        <span className="fa-stack icon-stack cursor">
          <label className="fa-stack cursor" htmlFor="imageavatar">
            <i
              className={`far fa-circle fa-stack-2x ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
            <span className="fa fa-stack-1x">
              <i className="fas fa-plus fa-lg white"></i>
            </span>
          </label>
          <input
            className="file-upload"
            type="file"
            name="file"
            id="imageavatar"
            multiple
            onChange={(e) => {
              setFile({
                ...imageFile,
                two: URL.createObjectURL(e.target.files[0]),
              });
              setDataFile({
                ...imageDataFile,
                two: e.target.files[0],
              });
            }}
          />
        </span>
      </div>
      <div className="background-image-container">
        {(community_banner === "Innovate_Me_logo_green.png" &&
          imageFile.one === "") ||
        (community_banner === "Innovate_Me_logo_red.png" &&
          imageFile.one === "") ||
        (community_banner === "Innovate_Me_logo_blue.png" &&
          imageFile.one === "") ? (
          <div className="profile-logo-container">
            <CommunityBanner />
          </div>
        ) : (
          <img
            className="background-image-container"
            src={
              role === "innovator" && imageFile.one === ""
                ? `https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/innovators/${community_banner}`
                : role === "mentor" && imageFile.one === ""
                ? `https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/mentors/${community_banner}`
                : role === "employer" && imageFile.one === ""
                ? `https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/employers/${community_banner}`
                : imageFile.one !== ""
                ? imageFile.one
                : ""
            }
            alt="background"
          />
        )}
      </div>
      <div className="mid-container-absolute">
        <div
          className={`avi-color-border ${
            role && role === "innovator"
              ? "green"
              : role && role === "mentor"
              ? "red"
              : role && role === "employer"
              ? "blue"
              : ""
          }`}
        >
          <img
            className="profile-avi"
            src={`${
              imageFile.two !== ""
                ? imageFile.two
                : `https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`
            }`}
            alt="avi"
          />
        </div>
      </div>
    </Fragment>
  );
};

ProfileBackgroundPicsEdit.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
});

export default connect(mapStateToProps)(ProfileBackgroundPicsEdit);
